import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      loading: false,

      login: async (email, password) => {
        set({ loading: true })
        try {
          // Integration point: Replace with actual API call
          // const response = await apiClient.post('/api/v1/auth/login', { email, password })
          // For now, mock login
          const mockUser = {
            id: '1',
            email,
            name: email.split('@')[0],
            role: 'admin',
            avatar: `https://ui-avatars.com/api/?name=${email}&background=0284c7&color=fff`,
          }
          const mockToken = 'mock-jwt-token-' + Date.now()

          set({
            user: mockUser,
            token: mockToken,
            isAuthenticated: true,
            loading: false,
          })
          return true
        } catch (error) {
          set({ loading: false })
          throw error
        }
      },

      logout: () => {
        set({
          user: null,
          token: null,
          isAuthenticated: false,
        })
      },

      updateUser: (updates) => {
        set((state) => ({
          user: { ...state.user, ...updates },
        }))
      },

      setToken: (token) => {
        set({ token })
      },
    }),
    {
      name: 'auth-store',
      getStorage: () => localStorage,
    }
  )
)
